import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=e185a492&scoped=true&"
import script from "./Banks.vue?vue&type=script&lang=js&"
export * from "./Banks.vue?vue&type=script&lang=js&"
import style0 from "./Banks.vue?vue&type=style&index=0&id=e185a492&lang=scss&scoped=true&"
import style1 from "./Banks.vue?vue&type=style&index=1&id=e185a492&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e185a492",
  null
  
)

export default component.exports